export default function getIndicesOf(str: string, search: string, oneTagClosesMultipleOpenTags = false) {
    const indexes = [];
    let startIndex = 0;
    let index = str.indexOf(search, startIndex);
    while (index !== -1) {
        indexes.push(index + (oneTagClosesMultipleOpenTags ? search.length : 0));
        startIndex = index + search.length;
        index = str.indexOf(search, startIndex);
    }
    return indexes;
}